import React from "react";
import PageTransition from "../Components/PageTransition";
import AnimatedHero from "../Components/AnimatedHero";
export default function RefundPolicy() {
  return (
    <PageTransition className="testimonials-page background">
      <AnimatedHero
        title="Refund & Cancellation Policy"
        subtitle="Thank you for supporting Darvik Foundation. Please read our refund and
        cancellation policy carefully."
        className="about-hero"
        overlayColor="rgba(14,77,109,0.15)"
      />
    <div className="container py-5">
      <h3>1. Donations</h3>
      <p>
        All donations made to Darvik Foundation are final and non-refundable.
        Donors are requested to verify donation details before proceeding.
      </p>

      <h3>2. Duplicate Transactions</h3>
      <p>
        In case of a duplicate donation or erroneous transaction, please contact
        us within 7 working days at{" "}
        <a href="mailto:contact@darvikfoundation.org">
          contact@darvikfoundation.org
        </a>
        . Refunds, if applicable, will be processed after verification and at
        the sole discretion of the Foundation.
      </p>

      <h3>3. Cancellation</h3>
      <p>
        Once a donation is made, it cannot be cancelled. Refunds will only be
        considered for accidental duplicate payments.
      </p>

      <h3>4. Contact Us</h3>
      <p>
        For refund requests or clarifications, please email us at{" "}
        <a href="mailto:contact@darvikfoundation.org">
          contact@darvikfoundation.org
        </a>{" "}
        or call us at{" "}
        <a href="tel:+919946613508">+91-99466-13508</a>.
      </p>
    </div>
    </PageTransition>
  );
}
